.wrapper {
    border-radius: 5px;
    position: relative;
    width: fit-content;
    height: fit-content;
    animation: fade-in 150ms ease-out;
    border: 1px solid var(--blue);
    transition: border-color 150ms ease-out;
}

.wrapper--hidden {
    border: 1px solid transparent;
}

.wrapper--hidden .icon {
    display: none;
}

.icon {
    position: absolute;
    top: -6px;
    right: -6px;
    z-index: 11; /* higher than our standard avatar z-indexes */
    animation: icon-fade-in 150ms ease-out;
}

@keyframes icon-fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .wrapper,
    .wrapper--hidden,
    .icon {
        animation: none;
    }
}
